<template>
  <div v-loading="!form" style="min-height: 500px">
  <el-row>  
  <el-col :span="12">
    <el-form v-if="form" ref="preferenesForm" :model="form" label-width="300px">
      <h3 style="margin-left: 30px">{{ $t("admin.logo") }}</h3>
      <el-form-item :label="$t('admin.companyLogo')" prop="Logo">
        <el-image v-if="!!form.logo" :src="form.logo"></el-image>
        <el-image
          v-if="!form.logo"
          style="width: 100%; height: 100%; display: flex; display: block"
        >
          <div slot="error" class="image-slot">
            <em class="el-icon-picture-outline"></em>
          </div>
        </el-image>
        <br />
        <input type="file" id="fileTitle" @change="loadFile()" ref="myFile" />
        <el-button
          type="danger"
          size="mini"
          @click="clearInput()"
          icon="el-icon-delete"
          circle
        ></el-button>
      </el-form-item>
      <h3 style="margin-left: 30px">{{ $t("admin.localization") }}</h3>
      <el-form-item :label="$t('admin.dateFormat')" prop="Date Format">
        <el-select style="width: 500px" v-model="form.localization.dateFormat">
          <el-option
            v-for="format of dateFormats"
            :label="format"
            :value="format"
            :key="format"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('admin.defaultLanguage')" prop="Language">
        <el-select
          style="width: 500px"
          v-model="form.localization.preferedLanguage"
        >
          <el-option
            v-for="language of languages"
            :label="language.label"
            :value="language.value"
            :key="language.value"
          />
        </el-select>
      </el-form-item>
      <h3 style="margin-left: 30px">{{ $t("home.alarms") }}</h3>
      <el-form-item :label="$t('alarms.mailTo')" prop="">
        <el-select
          filterable
          multiple
          allow-create
          style="width: 500px"
          v-model="form.alarm.mailReceivers"
        >
          <el-option
            v-for="user of users"
            :value="user.email"
            :label="`${user.name} ${user.surname}`"
            :key="user._id"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('alarms.frequencyAlarmMail')" prop="Language">
        <el-select style="width: 500px" v-model="form.alarm.frequencyAlarmMail">
          <el-option
            v-for="frequency of frequenciesOfAlarmMail"
            :value="frequency.value"
            :label="`${$t(`alarms.${frequency.label}`)}`"
            :key="frequency.value"
          />
        </el-select>
      </el-form-item>
       <el-form-item :label="$t('alarms.sensewayDisconnected')" prop="Language">
        <el-checkbox style="width: 500px" v-model="form.alarm.enableSensewayAlarm"/>
      </el-form-item>
      <el-form-item :label="$t('alarms.notificationTo')" prop="Language">
        <el-select
          multiple
          style="width: 500px"
          v-model="form.alarm.notificationReceivers"
        >
          <el-option
            v-for="user of users"
            :value="user._id"
            :label="`${user.name} ${user.surname}`"
            :key="user._id"
          />
        </el-select>
      </el-form-item>
      <h3 style="margin-left: 30px">{{ $t("alarms.autoAlarms") }}</h3>
      <el-form-item :label="$t('alarms.crest_star')">
        <el-checkbox v-model="form.alarm.autoAlarms.crest_star" />
      </el-form-item>
      <!-- <el-form-item :label="$t('alarms.mailAlarmLevels')">
        <el-slider
          v-model="form.alarm.alarmLevel"
          vertical
          :marks="marks"
          :max="3"
          :min="0"
          height="200px"
        >
        </el-slider>
      </el-form-item> -->
     
    </el-form>
    </el-col>
  <el-col :span="12">
  <h3 >{{ $t("admin.preference.passwordPolicy") }}</h3>
   <el-form v-if="form" label-position="left" class="password-policy">
   <el-form-item  :label="$t('admin.preference.passwordPolicy.minCharacter')" >
    <el-input-number size="small" v-model="form.passwordPolicy.minCharacter"  :min="4" :max="16"/>
     </el-form-item>
    <el-form-item  :label="$t('admin.preference.passwordPolicy.upperCaseLetter')" >
    <el-checkbox v-model="form.passwordPolicy.requiresUpperCaseLetters"  />
      </el-option>
   </el-form-item>
    <el-form-item  :label="$t('admin.preference.passwordPolicy.lowerCaseLetter')" >
    <el-checkbox v-model="form.passwordPolicy.requiresLowerCaseLetters"  />
      </el-option>
   </el-form-item>
     <el-form-item  :label="$t('admin.preference.passwordPolicy.numbers')" >
    <el-checkbox v-model="form.passwordPolicy.requiresNumbers"  />
      </el-option>
   </el-form-item>
     <el-form-item  :label="$t('admin.preference.passwordPolicy.specialCharacters')" >
    <el-checkbox v-model="form.passwordPolicy.requiresSpecialCharacters"  />
      </el-option>
   </el-form-item>
  
   </el-form>
  </el-col>
  </el-row>
 
  <el-row>
  <el-col :span="24" style="padding-left:32px;padding-right:32px">
    <el-form>
        <el-form-item prop="">
          <el-button type="primary" @click="save">{{
            $t("common.save")
          }}</el-button>
          <el-button style="float: right" @click="reset">{{
            $t("common.reset")
          }}</el-button>
        </el-form-item>
    </el-form>
  </el-col>
  </el-row>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { colorLib } from "../util";
import langTR from "element-ui/lib/locale/lang/tr-TR";
import langEN from "element-ui/lib/locale/lang/en";
import langRU from "element-ui/lib/locale/lang/ru-RU";
import langZHTW from "element-ui/lib/locale/lang/zh-TW";
import langZHCH from "element-ui/lib/locale/lang/zh-CN";
import langDE from "element-ui/lib/locale/lang/de";
import elLocale from "element-ui/lib/locale";
import axios from "axios";
import lodash from 'lodash'
let preferencesDefaults  ={
          "logo": "",
          "localization": {
            "dateFormat": "DD-MM-YYYY HH:mm:ss",
            "preferedLanguage": "tr",
            "timeZone": "GMT+3"
          },
          passwordPolicy: {
            "minCharacter": 8.0,
            "requiresUpperCaseLetters": false,
            "requiresLowerCaseLetters": false,
            "requiresNumbers": false,
            "requiresSpecialCharacters": false
          },
          "alarm": {
            "mailReceivers": [],
            "notificationReceivers": [],
            "autoAlarms": {
              "crest_star": false
            },
            "alarmLevel": 1
          }
        }
export default {
  name: "Admin_Preferences",
  components: {},
  data() {
    return {
       enableSensewayAlarm: false,
      
      frequenciesOfAlarmMail: [
        { value: 0, label: "immediately" },
        { value: 6, label: "6hour" },
        { value: 12, label: "12hour" },
        { value: 18, label: "18hour" },
        { value: 24, label: "24hour" },
        { value: 9999999, label: "dontWantMail" },
      ],
      marks: {
        3: {
          label: this.getAlarmLabel(3, this.$t("alarms.level3")),
        },
        2: {
          label: this.getAlarmLabel(2, this.$t("alarms.level2")),
        },
        1: {
          label: this.getAlarmLabel(1, this.$t("alarms.level1")),
        },
        0: {
          label: this.$t("alarms.level0"),
        },
        // 1:
        // 0: {
        //   style: {
        //     color: "#1989FA",
        //   },
        //   label: this.$createElement("strong", "50%"),
        // },
      },
      results: {},

      form: "",
      dateFormats: [
        "DD-MM-YYYY HH:mm:ss",
        "DD/MM/YYYY HH:mm:ss",
        "YYYY-MM-DD HH:mm:ss",
        "YYYY/MM/DD HH:mm:ss",
        "MM/DD/YYYY HH:mm:ss",
        "MM-DD-YYYY HH:mm:ss",
      ],
      languages: [
        {
          label: "English",
          value: "en",
        },
        {
          label: "Deutsch",
          value: "de",
        },
        {
          label: "Türkçe",
          value: "tr",
        },
        {
          label: "русский",
          value: "ru",
        },
        {
          label: "简体中文",
          value: "zh-tw",
        },
        {
          label: "繁體中文",
          value: "zh",
        },
      ],
    };
  },
  created() {
    this.init();
  },
  computed: {
   
    ...mapState("admin", ["users"]),
    ...mapState("account", ["customer"]),
    resultsTable() {
      return Object.keys(this.results);
    },
  },
  methods: {

    init() {
      this.loadPreferences();
     
    },
    handleLanguage(command) {
      this.$i18n.locale = command;
      localStorage.setItem("language", command);
      axios.defaults.headers.common["language"] = command;

      switch (command) {
        case "tr":
          elLocale.use(langTR);
          break;
        case "en":
          elLocale.use(langEN);
          break;
        case "ru":
          elLocale.use(langRU);
          break;
        case "zh-tw":
          elLocale.use(langZHCH);
          break;
        case "zh":
          elLocale.use(langZHTW);
          break;
        case "de":
          elLocale.use(langDE);
          break;
      }
    },
    clearInput() {
      this.form.logo = "";
      this.$refs.myFile.value = "";
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async loadFile() {
      console.log(this.$refs.myFile.files[0]);
      let preURL = await this.toBase64(this.$refs.myFile.files[0]);
      this.form.logo = await this.resizeImage(preURL, 300, 40);
      let temporary = this.form.logo;
      this.form.logo = !this.form.logo;
      this.form.logo = temporary;
    },
    async resizeImage(base64Str, maxWidth, maxHeight) {
      return new Promise((resolve) => {
        let img = new Image();
        img.src = base64Str;
        img.onload = () => {
          let canvas = document.createElement("canvas");
          // const MAX_WIDTH = maxWidth;
          const MAX_HEIGHT = maxHeight;
          let width = img.width;
          let height = img.height;
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
          // if (width > height) {
          //   if (width > MAX_WIDTH) {
          //     height *= MAX_WIDTH / width;
          //     width = MAX_WIDTH;
          //   }
          // } else {
          //   if (height > MAX_HEIGHT) {
          //     width *= MAX_HEIGHT / height;
          //     height = MAX_HEIGHT;
          //   }
          // }
          canvas.width = width;
          canvas.height = height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL());
        };
      });
    },
    getAlarmLabel(order, text) {
      return this.$createElement(
        "span",
        {
          style: {
            display: "flex",
            "flex-direction": "row",
            "align-items": "baseline",
            "vertical-align": "initial",
            "justify-content": "flex-start",
            width: "60px",
          },
        },
        [
          this.$createElement("i", {
            class: "color-box",
            style: {
              "background-color": this.getColor(order),
            },
          }),
          this.$createElement(
            "span",
            { style: { "margin-left": "5px" } },
            text
          ),
        ]
      );
    },
    ...mapActions("account", ["loadCustomer"]),
    ...mapActions("admin", ["updatePreferences"]),
    save() {
      this.updatePreferences(JSON.parse(JSON.stringify(this.form)))
        .then(this.loadCustomer)
        .then(() => {
          this.$message.success(this.$t("common.saved"));
          this.handleLanguage(this.form.localization.preferedLanguage);
          location.reload();
        });
    },
    reset() {
      this.loadPreferences()
      
    },
    loadPreferences(){
       this.loadCustomer().then(() => {
        
        this.form = lodash.mergeWith(preferencesDefaults,this.customer.preferences)
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    getColor(order) {
      return colorLib.getAlarmColorByOrder(order);
    },
  },
};
</script>
<style>
p {
  margin-left: 30px;
}
.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}
.vue-phone-number-input .select-country-container {
  min-width: 100px !important;
  max-width: 100px !important;
}
.password-policy .el-form-item{
  margin:0

}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}
.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}
.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 500px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>